<div
  #transcript
  class="chat-transcript"
  role="log"
  aria-live="polite"
  aria-relevant="additions text"
  [attr.aria-label]="'Chat.Messages' | translate"
  [attr.aria-busy]="chat.busy()"
>
  @for (message of chat.messages(); track message.id) {
  <article
    class="chat-message"
    [class.chat-message-user]="message.role === 'user'"
  >
    <span class="chat-author">{{ (message.role === 'user' ? 'Chat.You' : 'Chat.Title') | translate }}</span>
    @if (message.role === 'user') {
    <div class="chat-user-text">{{ message.text }}</div>
    } @else {
    <div
      class="chat-markdown"
      [innerHTML]="renderMarkdown(message.text)"
    ></div>
    } @if (message.actions.length) {
    <div class="chat-suggestions">
      @for (action of message.actions; track $index) {
      <button
        kendoButton
        type="button"
        [themeColor]="action.primary ? 'primary' : 'base'"
        [disabled]="!chat.canSend()"
        (click)="chat.invokeAction(message.id, action)"
      >
        {{ action.label }}
      </button>
      }
    </div>
    } @if (message.suggestions.length && $last) {
    <div class="chat-suggestions">
      @for (suggestion of message.suggestions; track $index) {
      <button
        kendoButton
        type="button"
        [disabled]="!chat.canSend()"
        (click)="send(suggestion)"
      >
        {{ suggestion }}
      </button>
      }
    </div>
    }
  </article>
  }
</div>
@if (chat.busy()) {
<div
  class="chat-status"
  role="status"
>
  {{ (chat.connected() ? 'Chat.Replying' : 'Chat.Connecting') | translate }}
</div>
} @if (chat.error(); as error) {
<div
  class="chat-error"
  role="alert"
>
  <span>{{ error | translate }}</span>
  @if (chat.signInRequired()) {
  <p>{{ 'Chat.RedirectWarning' | translate }}</p>
  <button
    kendoButton
    type="button"
    [svgIcon]="loginIcon"
    [title]="'Chat.SignIn' | translate"
    [attr.aria-label]="'Chat.SignIn' | translate"
    (click)="chat.signIn()"
  ></button>
  } @else if (!chat.connected() && chat.configured()) {
  <button
    kendoButton
    type="button"
    [svgIcon]="retryIcon"
    [title]="'Chat.RetryConnection' | translate"
    [attr.aria-label]="'Chat.RetryConnection' | translate"
    [disabled]="chat.busy()"
    (click)="chat.connect()"
  ></button>
  }
</div>
}
<form
  class="chat-composer"
  [formGroup]="form"
  (ngSubmit)="send()"
>
  <textarea
    formControlName="message"
    rows="2"
    maxlength="8000"
    [readOnly]="chat.busy()"
    [placeholder]="'Chat.Message' | translate"
    [attr.aria-label]="'Chat.Message' | translate"
    (input)="rememberDraft()"
    (keydown)="onComposerKeydown($event)"
  ></textarea>
  <button
    kendoButton
    type="submit"
    themeColor="primary"
    [svgIcon]="sendIcon"
    [title]="'Chat.Send' | translate"
    [attr.aria-label]="'Chat.Send' | translate"
    [disabled]="!chat.canSend() || form.invalid"
  ></button>
</form>
